import React from 'react';

import BoldText from 'marketing-website/components/commons/BoldText';

const ebookData = [
  <BoldText
    copy1={'New ways to '}
    emphasise={'drive design understanding and critique'}
    copy2={'throughout your team'}
  />,
  <BoldText
    copy1={'The'}
    emphasise={'impact of inconsistency'}
    copy2={'in design handover and the key sources to look out for'}
  />,
  <BoldText
    emphasise={'Methods of ensuring consistency,'}
    copy2={'touching on design systems and opening up the design process'}
  />,
  <BoldText
    emphasise={'The essential moments to check in with developers'}
    copy2={'during the design process'}
  />,
];
export default ebookData;



// WEBPACK FOOTER //
// ./src/configs/pages/ebook/ebook.js